<template>
  <app-collapse>
    <app-collapse-item
      :is-visible="true"
      :title="label"
    >
      <div class="document-editor">
        <div class="document-editor__toolbar" />
        <div class="document-editor__editable-container">
          <ckeditor
            :id="id"
            v-model="selfValue"
            :editor="editor"
            :config="editorConfig"
            @ready="onReadyCkeditor"
          />
        </div>
      </div>
    </app-collapse-item>
  </app-collapse>
</template>
<script>
import 'bootstrap-vue'
import { uploader } from '@/@core/utils/UploadAdapter'
import { iframe } from '@/@core/utils/Iframe'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import DocumentEditor from '@ckeditor/ckeditor5-build-decoupled-document'

export default {
  name: 'CkeditorBasic',
  components: {
    AppCollapseItem,
    AppCollapse,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: '',
    },
    value: null, // any value type
  },
  data() {
    return {
      selfValue: '',
      editor: DocumentEditor,
      defaultConfig: {
        isReadOnly: false,
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: '',
        language: 'fa',
        mediaEmbed: {
          extraProviders: [{
            name: 'aparat',
            // url: /^aparat\.com\/video\/video\/embed\/videohash\/(\w+)\/vt\/frame/,
            url: /^.+/,
            html: match => {
              const data = match[0]
              const code = data[0] !== '<' ? data.slice(8) : data
              return `<div style="height:315px;width:560px;">${code}</div>`
            },
          }],
          previewsInData: true,
        },
        extraPlugins: [uploader, iframe],
        heading: {
          options: [{
            model: 'paragraph',
            title: 'پاراگراف',
            class: 'ck-heading_paragraph',
          }, {
            model: 'heading1',
            view: 'h1',
            title: 'عنوان ۱',
            class: 'ck-heading_heading1',
          }, {
            model: 'heading2',
            view: 'h2',
            title: 'عنوان ۲',
            class: 'ck-heading_heading2',
          }, {
            model: 'heading3',
            view: 'h3',
            title: 'عنوان ۳',
            class: 'ck-heading_heading3',
          }, {
            model: 'heading4',
            view: 'h4',
            title: 'عنوان ۴',
            class: 'ck-heading_heading4',
          }],
        },
      },
    }
  },
  computed: {
    editorConfig() {
      return {
        ...this.defaultConfig,
        ...this.config,
      }
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.setValue(newVal)
      }
    },
  },
  methods: {
    setValue(val) {
      this.selfValue = val
    },
    sendValToForm() {
      this.$emit('input', this.selfValue)
    },
    onReadyCkeditor(editor) {
      const toolbarContainer = document.querySelector('.document-editor__toolbar')
      toolbarContainer.appendChild(editor.ui.view.toolbar.element)
    },
  },
}
</script>
<style>
.document-editor {
        border: 1px solid var(--ck-color-base-border);
        border-radius: var(--ck-border-radius);

        /* Set vertical boundaries for the document editor. */
        max-height: 700px;

        /* This element is a flex container for easier rendering. */
        display: flex;
        flex-flow: column nowrap;
    }

    .document-editor__toolbar {
        /* Make sure the toolbar container is always above the editable. */
        z-index: 1;

        /* Create the illusion of the toolbar floating over the editable. */
        box-shadow: 0 0 5px hsla( 0,0%,0%,.2 );

        /* Use the CKEditor CSS variables to keep the UI consistent. */
        border-bottom: 1px solid var(--ck-color-toolbar-border);
    }

    /* Adjust the look of the toolbar inside the container. */
    .document-editor__toolbar .ck-toolbar {
        border: 0;
        border-radius: 0;
    }

    /* Make the editable container look like the inside of a native word processor application. */
    .document-editor__editable-container {
        padding: calc( 2 * var(--ck-spacing-large) );
        background: var(--ck-color-base-foreground);

        /* Make it possible to scroll the "page" of the edited content. */
        overflow-y: scroll;
    }

    .document-editor__editable-container .ck-editor__editable {
        /* Set the dimensions of the "page". */
        width: 95%;
        min-height: 21cm;

        /* Keep the "page" off the boundaries of the container. */
        padding: 1cm;

        border: 1px hsl( 0,0%,82.7% ) solid;
        border-radius: var(--ck-border-radius);
        background: white;

        /* The "page" should cast a slight shadow (3D illusion). */
        box-shadow: 0 0 5px hsla( 0,0%,0%,.1 );

        /* Center the "page". */
        margin: 0 auto;
    }

    /* Set the default font for the "page" of the content. */
    /* .document-editor .ck-content,
    .document-editor .ck-heading-dropdown .ck-list .ck-button__label {
        font: 16px/1.6 "Helvetica Neue", Helvetica, Arial, sans-serif;
    } */

    /* Adjust the headings dropdown to host some larger heading styles. */
    .document-editor .ck-heading-dropdown .ck-list .ck-button__label {
        line-height: calc( 1.7 * var(--ck-line-height-base) * var(--ck-font-size-base) );
        min-width: 100%;
    }

    /* Scale down all heading previews because they are way too big to be presented in the UI.
    Preserve the relative scale, though. */
    .document-editor .ck-heading-dropdown .ck-list .ck-button:not(.ck-heading_paragraph) .ck-button__label {
        transform: scale(0.8);
        transform-origin: left;
    }

    .h_iframe-aparat_embed_frame iframe{
      height:315px;
      width:560px;
    }
    .h_iframe-aparat_embed_frame span{
      padding: 0 !important;
    }
    /* Make the block quoted text serif with some additional spacing. */
    /* .document-editor .ck-content blockquote {
        font-family: Georgia, serif;
        margin-left: calc( 2 * var(--ck-spacing-large) );
        margin-right: calc( 2 * var(--ck-spacing-large) );
    } */
  </style>
